module.exports = __webpack_public_path__ + "static/img/level4.5c2e771b.png";